export default "__VITE_ASSET__BE5sN1Ou__"